import { render, staticRenderFns } from "./TravelInfoList.vue?vue&type=template&id=73dd4d80&scoped=true&"
import script from "./TravelInfoList.vue?vue&type=script&lang=js&"
export * from "./TravelInfoList.vue?vue&type=script&lang=js&"
import style0 from "./TravelInfoList.vue?vue&type=style&index=0&id=73dd4d80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73dd4d80",
  null
  
)

export default component.exports